import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Toaster } from 'react-hot-toast';

import HomePage from './pages/HomePage';
import EventPage from './pages/EventPage';
import CheckoutPage from './pages/CheckoutPage';
import TicketPage from './pages/TicketPage';
import VerifyPage from './pages/VerifyPage';
import LoginPage from './pages/organizer/LoginPage';
import RegisterPage from './pages/organizer/RegisterPage';
import DashboardPage from './pages/organizer/DashboardPage';
import CreateEventPage from './pages/organizer/CreateEventPage';
import MyTicketsPage from './pages/MyTicketsPage';
import SuperAdminPage from './pages/SuperAdminPage';
import PayoutsPage from './pages/organizer/PayoutsPage';
import ForgotPasswordPage from './pages/organizer/ForgotPasswordPage';
import ResetPasswordPage from './pages/organizer/ResetPasswordPage';

function OrganizerRoute({ children }) {
  const { organizer, loading } = useAuth();
  if (loading) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}><div style={{ width: 40, height: 40, border: '4px solid #E8521A', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} /></div>;
  return organizer ? children : <Navigate to="/organizer/login" />;
}

export default function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" />
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        * { box-sizing: border-box; }
        body { margin: 0; font-family: 'DM Sans', sans-serif; background: #f8f9fa; }
        a { text-decoration: none; }
      `}</style>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/" element={<HomePage />} />
          <Route path="/event/:id" element={<EventPage />} />
          <Route path="/checkout/:id" element={<CheckoutPage />} />
          <Route path="/ticket/:code" element={<TicketPage />} />
          <Route path="/verify/:code" element={<VerifyPage />} />
          <Route path="/my-tickets" element={<MyTicketsPage />} />
          {/* Organizer */}
          <Route path="/organizer/login" element={<LoginPage />} />
          <Route path="/organizer/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/organizer/reset-password/:token" element={<ResetPasswordPage />} />
          <Route path="/organizer/register" element={<RegisterPage />} />
          <Route path="/organizer/dashboard" element={<OrganizerRoute><DashboardPage /></OrganizerRoute>} />
          <Route path="/organizer/events/new" element={<OrganizerRoute><CreateEventPage /></OrganizerRoute>} />
          <Route path="/organizer/payouts" element={<OrganizerRoute><PayoutsPage /></OrganizerRoute>} />
          <Route path="/super-admin" element={<SuperAdminPage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
